<app-section-grid *ngIf="!embeddedMode" [subSection]="'Create Social Platform'"></app-section-grid>

<app-stepper-grid *ngIf="!embeddedMode"></app-stepper-grid>

<div 
  class="relative w-full mx-auto p-10 bg-white rounded-3xl mb-5"
  [class.border]="hasBorder"
  [class.border-gray-200]="hasBorder"
  style="max-width: 760px;">

    <form [formGroup]="platformForm" (ngSubmit)="onSubmit()">
        <!-- Header -->
        <div class="text-center mb-10">
            <h1 class="text-3xl font-bold text-gray-800 tracking-tight">Social Platform Details</h1>
            <p class="mt-2 text-gray-500">Enter the social platfom details below</p>
        </div>

        <!-- Centered fields block -->
        <div class="w-full max-w-3xl mx-auto">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <!-- Platform -->
                <div>
                    <label class="block text-sm font-semibold text-gray-700 mb-2">🏷️ Platform <small
                            class="text-red-300">(required)</small></label>
                    <select formControlName="platform" class="cursor-pointer w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors">
                        <option value="" disabled>Select platform</option>
                        <option value="Facebook">Facebook</option>
                        <option value="Instagram">Instagram</option>
                        <!-- <option value="TikTok">TikTok</option> -->
                    </select>

                    <div *ngIf="platformForm.get('platform')?.touched && platformForm.get('platform')?.invalid"
                        class="mt-1 text-xs text-red-500">
                        <span *ngIf="platformForm.get('platform')?.hasError('required')">Platform is required.</span>
                    </div>
                </div>

                <!-- Sites -->
                <div>
                    <label class="block text-sm font-semibold text-gray-700 mb-2">🗂️ Sites</label>
                    <select formControlName="ms_contentsite_id" [disabled]="hasDefaultSite" class="cursor-pointer w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors disabled:bg-gray-100 disabled:cursor-not-allowed disabled:text-gray-500">
                        <option value="" disabled>Select social page/site</option>

                        <option *ngFor="let site of siteOptions" [value]="site.ID"
                            [disabled]="site.isApproved !== 'Approved' || site.Domain === 'default' || site.siteUrl === 'default'">
                            {{ site.Domain || 'Default site #' + site.ID }}
                    </select>
                    <p *ngIf="hasDefaultSite" class="text-xs text-gray-500 mt-1">
                        Default/null site is enforced.
                    </p>

                    <div *ngIf="platformForm.get('ms_contentsite_id')?.touched && platformForm.get('ms_contentsite_id')?.invalid"
                        class="mt-1 text-xs text-red-500">
                        <span *ngIf="platformForm.get('ms_contentsite_id')?.hasError('required')">Site is
                            required.</span>
                    </div>
                </div>

                <!-- Social Media ID (textarea rows=1 to match your style) -->
                <div>
                    <label class="block text-sm font-semibold text-gray-700 mb-2">🆔 Page ID <small
                            class="text-red-300">(required)</small></label>
                    <textarea formControlName="social_media_id" rows="1" (keydown.enter)="$event.preventDefault()"
                        placeholder="Enter Page ID..."
                        class="w-full resize-none border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>

                    <div *ngIf="platformForm.get('social_media_id')?.touched && platformForm.get('social_media_id')?.invalid"
                        class="mt-1 text-xs text-red-500">
                        <span *ngIf="platformForm.get('social_media_id')?.hasError('required')">Page ID is
                            required.</span>
                    </div>
                </div>

                <!-- Access Token -->
                <div>
                    <label class="block text-sm font-semibold text-gray-700 mb-2">🔑 Access Token <small
                            class="text-red-300">(required)</small></label>
                    <textarea formControlName="access_token" rows="1" (keydown.enter)="$event.preventDefault()"
                        placeholder="Enter access token..."
                        class="w-full resize-none border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>

                    <div *ngIf="platformForm.get('access_token')?.touched && platformForm.get('access_token')?.invalid"
                        class="mt-1 text-xs text-red-500">
                        <span *ngIf="platformForm.get('access_token')?.hasError('required')">Access Token is
                            required.</span>
                        <span *ngIf="platformForm.get('access_token')?.hasError('minlength')">
                            Access Token must be at least 190 characters.
                        </span>
                    </div>
                </div>

                <!-- APP ID -->
                <div>
                    <label class="block text-sm font-semibold text-gray-700 mb-2">📎 App ID <small
                            class="text-red-300">(required)</small></label>
                    <textarea formControlName="app_id" rows="1" (keydown.enter)="$event.preventDefault()"
                        placeholder="Enter App ID..."
                        class="w-full resize-none border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>

                    <div *ngIf="platformForm.get('app_id')?.touched && platformForm.get('app_id')?.invalid"
                        class="mt-1 text-xs text-red-500">
                        <span *ngIf="platformForm.get('app_id')?.hasError('required')">App ID is required.</span>
                        <span *ngIf="platformForm.get('app_id')?.hasError('minlength')">
                            App ID is required.
                        </span>
                    </div>
                </div>

                <!-- APP Secret -->
                <div>
                    <label class="block text-sm font-semibold text-gray-700 mb-2">🔐 App Secret <small
                            class="text-red-300">(required)</small></label>
                    <textarea formControlName="app_secret" rows="1" (keydown.enter)="$event.preventDefault()"
                        placeholder="Enter App Secret..."
                        class="w-full resize-none border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>

                    <div *ngIf="platformForm.get('app_secret')?.touched && platformForm.get('app_secret')?.invalid"
                        class="mt-1 text-xs text-red-500">
                        <span *ngIf="platformForm.get('app_secret')?.hasError('required')">App Secret is
                            required.</span>
                        <span *ngIf="platformForm.get('app_secret')?.hasError('minlength')">
                            App Secret is required.
                        </span>
                    </div>
                </div>
            </div>



            <!-- FACEBOOK PROMPTS -->
            <div *ngIf="showPromptField && showFbPrompts" class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                <div>
                    <label class="block text-sm font-semibold text-gray-700 mb-2">📘 Facebook Default Prompt</label>
                    <textarea formControlName="fbDefaultPrompt" rows="3" placeholder="Enter description..."
                        class="w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>
                </div>

                <div>
                    <label class="block text-sm font-semibold text-gray-700 mb-2">📘 Facebook Alternative Prompt</label>
                    <textarea formControlName="fbAlternativePrompt" rows="3" placeholder="Enter description..."
                        class="w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>
                </div>
            </div>

            <!-- INSTAGRAM PROMPTS -->
            <div *ngIf="showPromptField && showIgPrompts" class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                <div>
                    <label class="block text-sm font-semibold text-gray-700 mb-2">📷 Instagram Default Prompt</label>
                    <textarea formControlName="igDefaultPrompt" rows="3" placeholder="Enter description..."
                        class="w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>
                </div>

                <div>
                    <label class="block text-sm font-semibold text-gray-700 mb-2">📷 Instagram Alternative
                        Prompt</label>
                    <textarea formControlName="igAlternativePrompt" rows="3" placeholder="Enter description..."
                        class="w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>
                </div>
            </div>

            <!-- TIKTOK PROMPTS -->
            <div *ngIf="showPromptField && showTikTokPrompts" class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                <div>
                    <label class="block text-sm font-semibold text-gray-700 mb-2">📷 TikTok Default Prompt</label>
                    <textarea formControlName="tikTokDefaultPrompt" rows="3" placeholder="Enter description..."
                        class="w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>
                </div>

                <div>
                    <label class="block text-sm font-semibold text-gray-700 mb-2">📷 TikTok Alternative Prompt</label>
                    <textarea formControlName="tikTokAlternativePrompt" rows="3" placeholder="Enter description..."
                        class="w-full border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors"></textarea>
                </div>
            </div>

            <app-submit-grid></app-submit-grid>

        </div>
    </form>
</div>

<app-footer-grid *ngIf="!embeddedMode"></app-footer-grid>
